import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

/**
 * BUG-H7 : périmètre d'erreur React.
 * Intercepte les erreurs de rendu (y compris les échecs de chargement de chunks
 * lazy après un déploiement) pour éviter un écran blanc, et propose un rechargement.
 *
 * Astuce : monter ce composant avec une `key` liée à la page courante permet de
 * réinitialiser l'état d'erreur lors d'un changement de page (récupération).
 */
class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary a intercepté une erreur:', error, info);
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div
          className="tmb-card"
          style={{ margin: 24, padding: 24, textAlign: 'center', maxWidth: 480 }}
        >
          <h2 style={{ marginTop: 0, fontSize: 'var(--fs-lg, 16px)' }}>
            Une erreur est survenue
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>
            L'affichage de cette section a échoué. Cela peut se produire après une
            mise à jour de l'application.
          </p>
          <button className="tmb-btn" onClick={this.handleReload} style={{ marginTop: 8 }}>
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
